import React, { useState } from 'react';
import swal from 'sweetalert';


export default function ResetPW() {

  const [show, setShow] = useState(true);
  const [oldPw, setOldPw] = useState('')
  const [newPw, setNewPw] = useState('')
  const [cnfPw, setCnfPw] = useState('')
  const userid = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const apiPath = "https://ads-api.adshospital.site/api/V1/"

  let txt = "";

  function closeModalHandler() {
    setShow(false);

  }

  async function changePasswpord(userid) {
    //   alert(userid)
    if (newPw !== cnfPw) {
      swal("Please Confirm correct password");
      return
    }
    else {
      let result = await fetch(apiPath + "changepassword/" + userid, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
          //        "token":"IG0k6Y1qfvt_dA-4oSzsBNoP_BDqRDUm"

        },
        body: JSON.stringify({
          "user_id": userid,
          "oldpassword": oldPw,
          "newpassword": newPw
        })
      });

      result = await result.json();
      showSwal(result.success, result.message)


    }
  }

  function showSwal(stat, txt) {
    if (stat === 'success') {
      swal({
        title: stat,
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


  return (
    <>
      <div className='Model-content' style={{
        transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
        opacity: show ? '1' : '0'
      }} >
        <div className="modal-wrapper"></div>

        <div className="modal-container">

          <div className="modal-header">
            <h2>Change of Password</h2>
            <span onClick={closeModalHandler} className="close-modal-btn">x</span>
          </div>

          <div className="modal-body">

            <input type="password" className="box small"
              placeholder="Old Password" onChange={(e) => setOldPw(e.target.value)} />

            <input type="password" className="box small"
              placeholder="New Password" onChange={(e) => setNewPw(e.target.value)} />

            <input type="password" className="box small"
              placeholder="Confirm Password" onChange={(e) => setCnfPw(e.target.value)} />

            <br /><br />
            <button onClick={changePasswpord} type="button" name="button"
              className="btn solid round">Change Password</button>
          </div>

          <div className="modal-footer">
            <button onClick={closeModalHandler} className="btn-cancel">Close</button>
          </div>

        </div>
      </div>
    </>
  )
}
